import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
  status?: string;
}

export function ProgressBar({ current, total, status }: ProgressBarProps) {
  const percentage = Math.round((current / total) * 100);

  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4">
      <div
        className="bg-indigo-600 h-2.5 rounded-full transition-all duration-500 ease-in-out"
        style={{ width: `${percentage}%` }}
      />
      <div className="text-sm text-gray-600 mt-2 text-center">
        {status || `Generating chapter ${current} of ${total}`}
      </div>
    </div>
  );
}
